import React from 'react'
import ButtonV2 from '../../../common/components/atom/ButtonV2/Button'
import type { Range } from '../types/joulyDailyTypes'

export interface QuickRangeSelectorProps {
  value: Range
  onChange: (r: Range) => void
}

const RANGES: { value: Range; label: string }[] = [
  { value: '7d',  label: '7j'  },
  { value: '30d', label: '30j' },
  { value: '90d', label: '90j' },
]

export default function QuickRangeSelector({ value, onChange }: QuickRangeSelectorProps) {
  return (
    <div
      role="group"
      aria-label="Sélection de la période"
      style={{ display: 'flex', gap: 8 }}
    >
      {RANGES.map((r) => (
        <ButtonV2
          key={r.value}
          onClick={() => onChange(r.value)}
          variant={value === r.value ? 'contained' : 'bordered'}
          color="primary"
          size="small"
          aria-pressed={value === r.value}
          aria-label={`Période ${r.label}`}
        >
          {r.label}
        </ButtonV2>
      ))}
    </div>
  )
}
